import { Component, Inject, OnInit } from '@angular/core';
import { APP_VERSION_SERVICE, INativeAppVersionService } from '@boxx/core';

@Component({
  selector: 'boxx-native-version-info',
  templateUrl: './native-version-info.component.html',
  styleUrls: ['./native-version-info.component.scss'],
})
export class NativeVersionInfoComponent implements OnInit {
  constructor(
    @Inject(APP_VERSION_SERVICE)
    public appVersionService: INativeAppVersionService,
  ) {}

  ngOnInit() {}
}
